<template>
  <v-bar-chart-card
    title="위험성평가 현황"
    use-select-year
    is-move-detail
    :series="series"
    :colors="['#7E72F2', '#F99600', '#333333']"
    :categories="categories"
    total-label="실시총계"
    count-label="중요위험"
    :total-count="totalCount"
    :category-counts="categoryCounts"
    @select:year="onClickYear"
    :loading="isLoading"
    @detail="onClickDetail"
  >
    <template #right-buttons>
      <span class="btn-border py-1 px-2" :class="chartType === 'all' && 'active'" @click="onChangeChartType('all')">전체</span>
      <span class="btn-border py-1 px-2" :class="chartType === '직영' && 'active'" @click="onChangeChartType('직영')">직영</span>
      <span class="btn-border py-1 px-2" :class="chartType === '수급업체' && 'active'" @click="onChangeChartType('수급업체')">수급업체</span>
    </template>
  </v-bar-chart-card>
</template>

<script>
import VBarChartCard from "@/components/chart/VBarChartCard.vue";

export default {
  name: 'VBarChart306',
  components: {VBarChartCard},
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },

    totalCount() {
      return this.apiTotalCount || '0';
    },

    categoryCounts() {
      return this.apiCategoryCounts || [
        { name: "총계", count: 0 },
        { name: "개선 전", count: 0, prefix: "(" },
        { name: "개선 후", count: 0, suffix: ")" },
      ];
    },

    // 캐시 키 생성
    cacheKey() {
      return `graph-306-series-0-${this.year}-${this.chartType}-${this.projectId || 'all'}`;
    }
  },
  watch: {},
  data () {
    return {
      graphId: 306,
      series: [
        { name: "실시 건", data: [0, 0, 0, 0, 0], group: "single" }, // 단독 막대
        { name: "중요위험(개선 전)", data: [0, 0, 0, 0, 0], group: "group" }, // 스택 그룹
        { name: "중요위험(종결)", data: [0, 0, 0, 0, 0], group: "group" }, // 스택 그룹
      ],
      categories: ["본사", "인천공장", "포항공장", "당진공장", "중앙기술연구소"],
      //------------
      year: new Date().getFullYear(), // 평가일자 년도
      isLoading: false, // 로딩 상태
      cacheExpiry: 60 * 1000, // 캐시 만료 시간 (1분)
      chartType: 'all', // 전체
      apiTotalCount: '0',
      apiCategoryCounts: []
    }
  },
  async mounted () {
    await this.loadList();
  },
  methods: {
    onClickDetail() {
      const projectId = this.$route.params.proj_id;
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph/306`);
      } else {
        this.$router.push(`/project/2/graph/306`);
      }
    },

    async loadList() {
      this.isLoading = true;

      try {
        // 캐시 확인
        const cachedData = this.checkCache();

        if (cachedData) {
          this.series = cachedData.series;
          this.categories = cachedData.categories;
          this.apiTotalCount = cachedData.totalCount;
          this.apiCategoryCounts = cachedData.categoryCounts;

          setTimeout(() => {
            this.isLoading = false;
          }, 300);

          return;
        }

        // 새 API 호출
        const chartTypeMap = {
          'all': 'all',
          '직영': '직영',
          '수급업체': '수급'
        };

        const response = await this.$store.dispatch('summary/LOAD_VBAR_813_814_DETAIL', {
          year: this.year,
          chartType: chartTypeMap[this.chartType],
          projectId: this.projectId
        });

        // 응답 데이터 적용
        this.series = response.series;
        this.categories = response.categories;
        this.apiTotalCount = response.totalCount;
        this.apiCategoryCounts = response.categoryCounts;

        // 캐시 저장
        this.saveCache({
          series: this.series,
          categories: this.categories,
          totalCount: this.apiTotalCount,
          categoryCounts: this.apiCategoryCounts
        });

      } catch (error) {
        console.error('데이터 로드 중 오류 발생:', error);
      } finally {
        this.isLoading = false;
      }
    },


    // 캐시 확인 메서드
    checkCache() {
      try {
        const cacheKey = this.cacheKey;
        const cacheExpiryKey = `${cacheKey}-expiry`;

        const cachedData = localStorage.getItem(cacheKey);
        const cacheExpiry = localStorage.getItem(cacheExpiryKey);
        const currentTime = new Date().getTime();

        if (cachedData && cacheExpiry && currentTime < parseInt(cacheExpiry)) {
          return JSON.parse(cachedData);
        }
      } catch (error) {
        console.warn('캐시 확인 중 오류 발생:', error);
        // 기존 캐시 관련 항목 정리
        this.clearCache();
      }

      return null;
    },

    // 캐시 저장 메서드
    saveCache(data) {
      try {
        const cacheKey = this.cacheKey;
        const cacheExpiryKey = `${cacheKey}-expiry`;
        const currentTime = new Date().getTime();

        // 처리된 결과(series)만 저장하여 용량 절약
        localStorage.setItem(cacheKey, JSON.stringify(data));
        localStorage.setItem(cacheExpiryKey, (currentTime + this.cacheExpiry).toString());
      } catch (error) {
        console.warn('캐시 저장 중 오류 발생:', error);
        // 오류 발생 시 캐시 관련 항목 정리
        this.clearCache();
      }
    },

    // 캐시 정리 메서드
    clearCache() {
      try {
        // 현재 캐시 항목 삭제
        const cacheKey = this.cacheKey;
        const cacheExpiryKey = `${cacheKey}-expiry`;
        localStorage.removeItem(cacheKey);
        localStorage.removeItem(cacheExpiryKey);

        // 오래된 캐시나 불필요한 캐시 정리 (선택적)
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key.startsWith('graph-306-')) {
            keysToRemove.push(key);
          }
        }

        // 총 저장 용량을 줄이기 위해 일부 오래된 캐시 삭제
        keysToRemove.forEach(key => {
          localStorage.removeItem(key);
          localStorage.removeItem(`${key}-expiry`);
        });
      } catch (error) {
        console.warn('캐시 정리 중 오류 발생:', error);
        // 심각한 오류 시 모든 캐시 비우기 시도
        try {
          localStorage.clear();
        } catch (e) {
          console.error('localStorage 접근 불가:', e);
        }
      }
    },


    onClickYear(year) {
      if (this.year !== year) {
        this.year = year;
        this.loadList();
      }
    },

    // 캐시 강제 리프레시 메서드
    refreshData() {
      this.clearCache();
      this.loadList();
    },

    onChangeChartType(type) {
      this.chartType = type;
      this.loadList();
    },
  },

}
</script>

<style lang="scss" scoped>
.btn-border {
  font-size: 12px;
  min-width: 55px;
  border-radius: 999px;
  display: inline-block;
  text-align: center;
  cursor: pointer;

  border: 1px solid #cdcdcd;
  font-weight: 500;

  &.active {
    background-color: #6670cb;
    color: white;
  }
}
</style>
